<template>
  <Select v-model="data" ref="select" :disabled="disabled" clearable :transfer="transfer" :multiple="multiple" @on-change="onChange"
    @on-clear="clear" @on-open-change="openChange" transfer-class-name="org-select-tree" :max-tag-count="maxTagCount">
    <Option disabled :value="multiple?'':(data||'')" :label="multiple?'':(data||'')">
      <orgTree v-model="data" @change="selectNode" isSelect="1" ref="tree" :isAll="isAll" :multiple="multiple"></orgTree>
    </Option>
    <Option v-for="(item, i) in selectArr" :key="i" :value="item.id" v-show="false">{{item.name}}</Option>
  </Select>
</template>
<script>
import orgTree from "@/components/commons/orgTree/orgTree";
export default {
  components:{orgTree},
  props: {
    value: null,
    name: null,
    multiple:null,//是否显示多选框
    maxTagCount:{
      default:5,
    },
    type: null,//1 所有机构团队渠道，2所有机构团队，3所有机构渠道，4所有机构
    isAll: null,
    disabled: null,
    transfer: {
      default:true,
    },
  },
  data() {
    return {
      data:"",
      selectArr:[],
    };
  },
  watch: {
    name(){
      this.data = this.name;
    },
    value(val){
      if(!val){
        this.data = '';
      }
    }
  },
  methods: {
    openChange(){
      let url,params;
      if(this.type==1){//所有机构团队渠道
        url = "/buz/organizationBase/read/tree";
        params = {source:1};
      }else if(this.type==2){//所有机构渠道团队
        url = "/buz/organizationBase/read/tree";
        params = {source:2};
      }else if(this.type==3){//所有机构渠道
        url = "/buz/organizationBase/read/orgTree";
        params = {source:1};
      }else if(this.type==4){//所有机构
        url = "/buz/organizationBase/read/orgTree";
        params = {source:2};
      }else {
        this.$notice.msg("参数有误")
        return;
      }
      this.$refs.tree.init(url,params);
    },
    clear(){
      this.data = "";
      this.$emit("input",'');
      this.$emit("change",{});
    },
    selectNode(cur, nodeArr){
      if(this.multiple){
        this.data = nodeArr.map((item)=>{
          return item.id;
        })
        this.$emit("change",this.data);
        this.$emit("input",this.data);
        this.selectArr = nodeArr;
      }else{
        this.$refs.select.hideMenu();
        this.$emit("input",cur.id);
        this.$emit("change",cur);
        this.data = cur.name;
      }
      
    },
    onChange(data){
      if(this.multiple){
        this.$emit("change",data);
        this.$emit("input",data);
        // this.selectArr = nodeArr;
      }
    }
  },

};
</script>

<style lang="scss" scoped>
.ivu-transfer {
  text-align: center;
  /deep/ .ivu-transfer-list {
    text-align: left;
  }
}
.powerModal {
  /deep/ .ivu-modal-body {
    height: 500px;
    overflow-y: auto;
  }
}
</style>
